import { render } from "./labelMarketing_detail.vue?vue&type=template&id=71535f8e&scoped=true"
import script from "./labelMarketing_detail.vue?vue&type=script&lang=js"
export * from "./labelMarketing_detail.vue?vue&type=script&lang=js"

import "./labelMarketing_detail.vue?vue&type=style&index=0&id=71535f8e&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71535f8e"]])

export default __exports__